import { render, staticRenderFns } from "./tab-job-costing.vue?vue&type=template&id=59b0c058"
import script from "./tab-job-costing.vue?vue&type=script&lang=js"
export * from "./tab-job-costing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports